export default __webpack_public_path__ + "static/media/film-roll.b81c2f9d.svg";